/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFileFieldLook } from './DatabaseFileFieldLook';
import {
    DatabaseFileFieldLookFromJSON,
    DatabaseFileFieldLookFromJSONTyped,
    DatabaseFileFieldLookToJSON,
} from './DatabaseFileFieldLook';

/**
 * 
 * @export
 * @interface DatabaseFileField
 */
export interface DatabaseFileField extends DatabaseField {
    /**
     * 
     * @type {DatabaseFileFieldLook}
     * @memberof DatabaseFileField
     */
    type?: DatabaseFileFieldLook;
}

/**
 * Check if a given object implements the DatabaseFileField interface.
 */
export function instanceOfDatabaseFileField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFileFieldFromJSON(json: any): DatabaseFileField {
    return DatabaseFileFieldFromJSONTyped(json, false);
}

export function DatabaseFileFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFileField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabaseFileFieldLookFromJSON(json['type']),
    };
}

export function DatabaseFileFieldToJSON(value?: DatabaseFileField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'type': DatabaseFileFieldLookToJSON(value.type),
    };
}

